"use strict";

exports.__esModule = true;
exports.default = void 0;

var _pallette = _interopRequireDefault(require("./pallette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled-components theme for Reassure-UI form components
 */
const {
  transparent,
  white,
  black,
  paleBlue,
  lightBlue,
  darkBlue,
  midBlue,
  midGreen,
  lightPink,
  midRed
} = _pallette.default;
var _default = {
  colors: {
    formField: {
      focusHighlight: paleBlue
    },
    cardRadioGroup: {
      text: white,
      background: transparent,
      border: lightBlue,
      radio: white,
      hover: {
        text: white,
        background: midBlue,
        border: lightBlue,
        radio: white
      },
      checked: {
        text: white,
        background: lightBlue,
        border: lightBlue,
        radio: midGreen
      }
    },
    dropdown: {
      text: black,
      background: white,
      border: white,
      caret: midGreen,
      focus: {
        background: white,
        border: white,
        error: {
          background: white,
          border: midRed
        }
      },
      error: {
        background: white,
        border: midRed
      }
    },
    dropdownMenu: {
      text: white,
      background: transparent,
      border: midGreen,
      caret: midGreen,
      menu: {
        background: white
      },
      menuItem: {
        text: black,
        hover: {
          text: white,
          background: midGreen
        }
      }
    },
    input: {
      text: {
        text: black,
        background: white,
        border: white,
        focus: {
          background: white,
          border: white,
          error: {
            background: lightPink,
            border: midRed
          }
        },
        error: {
          background: lightPink,
          border: midRed
        }
      },
      checkbox: {
        background: white,
        border: white,
        checked: {
          background: transparent,
          border: midGreen,
          tickIcon: midGreen
        }
      }
    },
    label: {
      text: white
    },
    select: {
      text: black,
      background: white,
      border: white,
      caret: midGreen,
      focus: {
        background: white,
        border: white,
        error: {
          background: white,
          border: midRed
        }
      },
      error: {
        background: white,
        border: midRed
      }
    },
    toggleSwitch: {
      checked: {
        text: white,
        background: midGreen
      },
      unchecked: {
        text: white,
        background: transparent
      },
      switch: white,
      border: midGreen
    },
    slider: {
      marks: white,
      track: darkBlue,
      dots: {
        border: darkBlue,
        background: lightBlue
      },
      handle: {
        background: midGreen,
        bars: white
      }
    }
  }
};
exports.default = _default;